<template>
  <template v-if="selectedIds.length === 0">
    <p
      class="text-background-fg/87 mb-4 py-1 text-center text-sm"
    >
      No modifiers set on this product, click below to add
      modifiers
    </p>
  </template>

  <VDraggable
    v-model="fieldModel"
    item-key="key"
    handle=".handle"
    tag="ol"
    v-bind="dragOptions"
  >
    <template #item="{ element, index }">
      <li class="">
        <div
          class="bg-background flex items-center justify-between space-x-2"
        >
          <div>
            <button type="button" class="handle">
              <IconHeroiconsSolidBars3
                class="h-5 w-5 text-gray-400"
              />
            </button>
          </div>
          <ProductModifierGroupInfoCard
            :product-modifier-group-id="element.value"
          />
          <button
            class="flex items-center justify-center"
            @click="remove(index)"
          >
            <IconHeroiconsSolidMinus />
          </button>
        </div>
      </li>
    </template>
  </VDraggable>

  <div class="flex justify-around">
    <ButtonAdd @click="onAddProductModifierGroup">
      Add Modifier
    </ButtonAdd>
  </div>

  <ProductModifierGroupDialog
    ref="productModifierGroupDialogRef"
    :selected-group-ids="selectedIds"
    @push="push"
    @remove="removeByValue"
  />
</template>

<script setup lang="ts">
import type ProductModifierGroupDialog from "./ProductModifierGroupDialog.vue"
import VDraggable from "vuedraggable"

const $style = useCssModule()
const props = defineProps<{
  name: string
  label: string
}>()
const { fields, push, remove, removeByValue, replace } =
  useUniqueFieldArray<string>(toRef(props, "name"))

const fieldModel = computed({
  get: () => fields.value,
  set: (newFields) => {
    replace(newFields.map(({ value }) => value))
  },
})
const selectedIds = computed(() =>
  fields.value.map(({ value }) => value)
)

const productModifierGroupDialogRef =
  ref<InstanceType<typeof ProductModifierGroupDialog>>()
const onAddProductModifierGroup = async () => {
  if (!productModifierGroupDialogRef.value) return
  await productModifierGroupDialogRef.value.reveal()
}

const dragOptions = computed(() => ({
  animation: 200,
  ghostClass: $style.ghost,
  dragClass: $style.drag,
  direction: "vertical",
}))
</script>

<style lang="scss" module>
.ghost {
  opacity: 0;
}

.drag {
  opacity: 1;
}
</style>
